<app-simple-responsive-frame>
    <div class="image-container details">
        <h2>Revisa tus fotos.</h2>
        <p class="description">
            <b>Selecciona la imagen que deseas usar como portada para el anuncio.</b> <br>
            Asegúrate de que tus fotos cumplan con los
            <a href="#">Términos y Condiciones</a> de nuestra página.
        </p>

        <div class="image-grid">
            <div *ngFor="let category of imageCategories" class="image-item">
                <h5>{{ category.label }} <span *ngIf="category.mandatory">*</span></h5>

                <div class="image-gallery">
                    <img *ngFor="let image of category.images"
                         [src]="image.url"
                         [alt]="image.name"
                         class="image-preview"
                         [ngClass]="{'selected-image': selectedImage && selectedImage.id === image.id}"
                         (click)="selectImage(image)"/>
                </div>
            </div>
        </div>
    </div>

    <!-- Mensaje de error -->
    <div class="error-message" *ngIf="showErrorDialog">
        <ul class="text-danger list-unstyled" style="list-style: none; padding: 0; margin: 0; margin-top: 5px">
            <li><p-message severity="error" [text]="dialogCode + ' ' + dialogMessage"></p-message></li>
        </ul>
    </div>

    <app-page-navigation-bar
        [value]="60"
        [type]="'complete'"
        [previousPageURL]="previousUrl"
        [nextPageURL]="nextUrl"
        [flowMode]="currentMode"
        [stepKey]="'reviews'"
        (goNext)="handleNextStep()"
        (goPrevious)="handlePreviousStep()"
        (saveAndExit)="handleSaveAndExit()">
    </app-page-navigation-bar>
</app-simple-responsive-frame>

<p-toast></p-toast>
